import { KText } from '@/ui-library/components/text';
import { Avatar, Box, Flex, Icon } from '@chakra-ui/react';
import { formatStartAndEndDates } from '@/lib/util';
import { GraduationHat02 } from '@kula-ai/icons/outline/GraduationHat02';

export const EducationView = ({ education }) => {
  const eduLogo = education?.academic_institution?.logo || education?.logo;
  const eduName = education?.academic_institution?.name || education?.school;
  const eduDegName = education?.academic_degree?.name || education?.degree;
  const eduStart = education?.start_date || education?.from;
  const eduEnd = education?.end_date || education?.to;

  return (
    <Flex gap="12px" py="4px">
      {eduLogo ? (
        <Avatar
          width="32px"
          height="32px"
          borderRadius="6px"
          src={eduLogo}
          name={eduName}
        />
      ) : (
        <Box
          bg="secondary-50"
          borderRadius="6px"
          p="4px"
          width="36px"
          height="36px"
        >
          <Icon as={GraduationHat02} color="secondary-700" w="28px" h="20px" />
        </Box>
      )}
      <Flex gap="2px" flexDir="column">
        <KText size="sm-semi-bold">{eduName || '-'}</KText>
        <KText size="sm-regular">{eduDegName || '-'}</KText>
        <KText size="sm-regular">
          {formatStartAndEndDates(eduStart, eduEnd) || '-'}
        </KText>
      </Flex>
    </Flex>
  );
};
